<template>
  <div>
    <iframe
      class="blogDetailContainer"
      :src="$route.params.url"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "blogDetail",
  components: {},
  data: () => ({}),
  mounted() {
    // console.log('pppppppppppppp',this.$route.params)
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.blogDetailContainer {
  width: 100%;
  height: calc(100vh - 1.85rem);
}
</style>
